import * as React from 'react';
import PropTypes from 'prop-types';

export const PriceSection = (props) => {
    const priceDetails = props.pricingDetails.filter(product => product.type === props.contentId)[0];

    if(priceDetails && !priceDetails.errorFlag && priceDetails.minUnitListPrice && priceDetails.minUnitListPrice !== '') {
        if(priceDetails.minSaleListPrice && priceDetails.minSaleListPrice !== '' &&
            Number(priceDetails.minUnitListPrice) !== Number(priceDetails.minSaleListPrice)) {
            props.checkForDiscount(priceDetails.type);
            const saleTypeAmtText = priceDetails.saleTypeAmount ?
            `${(priceDetails.hasMultipleDiscounts ? 'Save up to ' : 'Save ') + priceDetails.saleTypeAmount}%`
            : null;
            return(
                <div className={'price-section'} id={`price-section-${props.contentId}`}>
                    {priceDetails.hasPriceRange ? 'From ' : ''}<strong className={'strike-through'} aria-label={`Original Price: ${priceDetails.minUnitListPrice}`}>${priceDetails.minUnitListPrice}</strong>&nbsp;
                    <br />
                    <span className={'discount-text'} aria-label={`Discounted price: ${priceDetails.minSaleListPrice} ${saleTypeAmtText}`}>
                        ${priceDetails.minSaleListPrice}&nbsp;<br />
                        {saleTypeAmtText}
                    </span>
                </div>
            );
        } else {
            return(
                <div className={'price-section'} id={`price-section-${props.contentId}`}>
                    {priceDetails.hasPriceRange ? 'From ' : ''}<strong>${priceDetails.minUnitListPrice}</strong>
                </div>
            );
        }
    }

    props.checkForError(props.contentId);

    return null;
};

PriceSection.propTypes = {
    contentId: PropTypes.string.isRequired,
    pricingDetails: PropTypes.array.isRequired,
    checkForDiscount: PropTypes.func,
    checkForError: PropTypes.func
};

PriceSection.defaultProps = {
    checkForDiscount: () => {},
    checkForError: () => {}
};
